import { render, staticRenderFns } from "./ProductsMainImage.vue?vue&type=template&id=534ff836&scoped=true&"
import script from "./ProductsMainImage.vue?vue&type=script&lang=js&"
export * from "./ProductsMainImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsMainImage.vue?vue&type=style&index=0&id=534ff836&prod&lang=css&"
import style1 from "./ProductsMainImage.vue?vue&type=style&index=1&id=534ff836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ff836",
  null
  
)

export default component.exports